import React from "react";
import AppTheme from "../../../service/app_config/AppTheme";
import { IconNormal } from "../../../widget/common/ui/Icon";
import { SearchContextImport } from "../../../provider/search/SearchContextProvider";
import { useDispatch } from "react-redux";
import { addModal } from "../../../libraries/state_reducers/widget/ModalsReducer";
import ModalKeys from "../../../const/ModalKeys";
import { setupGeoDetail } from "../../../libraries/state_reducers/country_state_city_area/CountyStateCityAreaReducer";

const SearchActions = () => {
  const dispatch = useDispatch();
  const {
    tabId,
    countryId,
    countryName,
    stateId,
    stateName,
    cityId,
    cityName,
    areaId,
    areaName,
    nearByStatus,
  } = SearchContextImport();

  const handleClickFilter = () => {
    dispatch(
      addModal({
        id: ModalKeys.search_filter,
        title: "filters",
      })
    );

    dispatch(
      setupGeoDetail({
        country: { country_id: countryId, country_name: countryName },
        state: { state_id: stateId, state_name: stateName },
        city: { city_id: cityId, city_name: cityName },
        area: { area_id: areaId, city_name: areaName },
        nearBy: nearByStatus,
      })
    );
  };

  return (
    <>
      {tabId === "1" && (
        <IconNormal
          name="filter"
          color={AppTheme.themeFont}
          handleClick={() => handleClickFilter()}
        />
      )}
    </>
  );
};

export default SearchActions;
